import { useCallback, useMemo, useState } from 'react';

export function useTabNavigation<TEnum extends number>(
  orderedTabs: readonly TEnum[],
  initialTab: TEnum,
) {
  const [tabIndex, setTabIndex] = useState<TEnum>(initialTab);

  const visualIndex = useMemo(
    () => orderedTabs.indexOf(tabIndex),
    [orderedTabs, tabIndex],
  );

  const onChangeTab = useCallback(
    (_: React.SyntheticEvent, index: number) => {
      setTabIndex(orderedTabs[index]);
    },
    [orderedTabs],
  );

  return { tabIndex, visualIndex, onChangeTab, setTabIndex };
}
